<div class="invoice-page">
  <div class="invoice-content">
 
    <div class="tab-navigation" *ngIf="activeBrandName === 'LFC'">
      <button class="tab-btn" [class.active]="activeTab === 'management'" (click)="switchTab('management')">Invoice Management</button>
      <button class="tab-btn" [class.active]="activeTab === 'import'" (click)="switchTab('import')">Import Invoice Data</button>
    </div>

    <!-- Management Tab -->
    <div *ngIf="activeTab === 'management'" class="management-tab-content">
      <div *ngIf="isLoading" class="tab-loading-overlay">
        <div class="spinner"></div>
      </div>

      <div class="selection-container">
        <label for="period-select-mgmt">Select Period</label>
        <select id="period-select-mgmt" data-testid="period-select" [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange($event)" class="period-select" [disabled]="isImporting">
          <option value="" disabled selected>Select Period</option>
          <option value="All Periods">All Periods</option>
          <option *ngFor="let period of periods" [value]="period">{{ period }}</option>
        </select>
      </div>

      <!-- Dashboard Stats -->
      <div class="dashboard-container" *ngIf="selectedPeriod && gridData.length > 0 && !isLoadingGrid && hasRates">
        <div class="stat-card">
          <div class="stat-title">Total Revenue (USD)</div>
          <div class="stat-value">{{ dashboardStats.totalRevenue | currency }}</div>
          <div class="stat-sub">Fees: {{ dashboardStats.totalFees | currency }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-title">Total Invoiced (USD)</div>
          <div class="stat-value">{{ dashboardStats.totalDue | currency }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-title">Collected (USD)</div>
          <div class="stat-value success">{{ dashboardStats.totalCollected | currency }}</div>
          <div class="progress-bar-bg">
            <div class="progress-bar-fill success" [style.width.%]="dashboardStats.collectionRate"></div>
          </div>
          <div class="stat-sub">{{ dashboardStats.collectionRate | number:'1.1-1' }}% Collected</div>
        </div>
        <div class="stat-card">
          <div class="stat-title">Total Due (USD)</div>
          <div class="stat-value danger">{{ dashboardStats.totalOutstanding | currency }}</div>
        </div>
        <div class="stat-card wide">
          <div class="stat-title">Invoice Status</div>
          <div class="status-chart">
            <div class="chart-bar-group" *ngFor="let status of ['Paid', 'Partial', 'Not Paid', 'Canceled']">
              <ng-container *ngIf="dashboardStats.statusCounts[status] > 0">
                <div class="chart-label">{{ status }}</div>
                <div class="chart-bar-container">
                  <div class="chart-bar" 
                       [class.paid]="status === 'Paid'" 
                       [class.partial]="status === 'Partial'" 
                       [class.not-paid]="status === 'Not Paid'" 
                       [class.canceled]="status === 'Canceled'"
                       [style.width.%]="(dashboardStats.statusCounts[status] / gridData.length) * 100">
                  </div>
                </div>
                <div class="chart-value">{{ dashboardStats.statusCounts[status] }}</div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Incentives KPI -->
      <div class="incentives-container" *ngIf="selectedPeriod && gridData.length > 0 && !isLoadingGrid && hasRates && incentiveStats.rateNames.length > 0">
        <h3 class="incentives-title">Fees Breakdown by Rate (USD)</h3>
        <div class="incentives-table-wrapper">
          <table class="incentives-table">
            <thead>
              <tr>
                <th></th>
                <th *ngFor="let name of incentiveStats.rateNames">{{ name }}</th>
                <th class="total-col-header">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="row-label">{{ activeBrandName === 'LFC' ? 'LK' : 'Commission' }}</td>
                <td *ngFor="let name of incentiveStats.rateNames">{{ incentiveStats.lfc[name] | currency }} <span style="font-size: 0.85em; color: #64748b;">({{ incentiveStats.lfcRates[name] }}%)</span></td>
                <td class="total-col">{{ incentiveStats.grandTotalLfc | currency }}</td>
              </tr>
              <tr>
                <td class="row-label">KCEG</td>
                <td *ngFor="let name of incentiveStats.rateNames">{{ incentiveStats.kceg[name] | currency }} <span style="font-size: 0.85em; color: #64748b;">({{ incentiveStats.kcegRates[name] }}%)</span></td>
                <td class="total-col">{{ incentiveStats.grandTotalKceg | currency }}</td>
              </tr>
              <tr class="total-row-kpi">
                <td class="row-label">Total</td>
                <td *ngFor="let name of incentiveStats.rateNames">{{ incentiveStats.total[name] | currency }}</td>
                <td class="total-col">{{ incentiveStats.grandTotal | currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="companies-section" *ngIf="selectedPeriod && !isImporting">
        <div class="toolbar-container">
          <button class="action-btn utility-btn" (click)="openRateCustomization()" [class.glow-btn]="!hasRates">Customize Rates</button>
          <div class="country-filter-dropdown">
            <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCountryFilterDropdown()">
              <span>{{ filterCountry === 'All' ? 'All Countries' : filterCountry }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCountryFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </button>
            <div class="dropdown-menu" *ngIf="showCountryFilterDropdown">
              <div class="dropdown-item" (click)="selectCountryFilter('All')">
                <span>All Countries</span>
              </div>
              <div class="dropdown-divider" *ngIf="availableCountries.length > 0"></div>
              <div class="dropdown-scroll">
                <div class="dropdown-item" *ngFor="let c of availableCountries" (click)="selectCountryFilter(c)">
                  <span>{{ c }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="company-filter-dropdown">
            <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCompanyFilterDropdown()">
              <span>Select Companies ({{ activeFilterCompanyIdsCount }}/{{ activeTabCompanies.length }})</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCompanyFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </button>
            <div class="dropdown-menu" *ngIf="showCompanyFilterDropdown">
              <div class="dropdown-item" style="padding: 4px 8px; cursor: default;" (click)="$event.stopPropagation()">
                <input type="text" [(ngModel)]="companyFilterSearchText" placeholder="Search company..." style="width: 100%; padding: 6px; border: 1px solid #cbd5e1; border-radius: 4px; box-sizing: border-box; font-size: 0.85rem;">
              </div>
              <div class="dropdown-item" (click)="toggleAllCompanyFilter()">
                <input type="checkbox" [checked]="isAllActiveCompaniesSelected" (click)="$event.stopPropagation(); toggleAllCompanyFilter()">
                <span>Select All</span>
              </div>
              <div class="dropdown-item" (click)="toggleKcegOwnedFilter()">
                <input type="checkbox" [checked]="isKcegOwnedSelected" (click)="$event.stopPropagation(); toggleKcegOwnedFilter()">
                <span>Select KCEG Owned</span>
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-scroll">
                <div class="dropdown-item" *ngFor="let company of filteredActiveTabCompanies" (click)="toggleCompanyFilterItem(company.id)">
                  <input type="checkbox" [checked]="filterCompanyIds.has(company.id)" (click)="$event.stopPropagation(); toggleCompanyFilterItem(company.id)">
                  <span>{{ company.company }}</span>
                </div>
              </div>
            </div>
          </div>
          <button class="action-btn utility-btn" (click)="isFilterRowVisible = !isFilterRowVisible">
            {{ isFilterRowVisible ? 'Hide Filters' : 'Show Filters' }}
          </button>
          <button *ngIf="activeBrandName !== 'LFC'" class="action-btn generate-btn" data-testid="btn-generate" (click)="generateInvoicesForSelectedBrand()" [disabled]="isGenerateDisabled" [title]="isGenerateDisabled ? 'Available starting from 08/2026' : 'Generate SMRS Invoices for ' + activeBrandName">
            <span *ngIf="isGeneratingInvoices" class="spinner-inline"></span>
            {{ isGeneratingInvoices ? 'Generating Invoices...' : '⚡ Generate SMRS Invoices' }}
          </button>
          <button *ngIf="canDeleteInvoices && selectedRowIds.size > 0" class="action-btn delete-btn" (click)="deleteSelectedInvoices()" [title]="'Delete ' + selectedRowIds.size + ' selected invoice(s)'">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: -2px; margin-right: 4px;"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
            Delete Selected ({{ selectedRowIds.size }})
          </button>
          <button class="action-btn save-btn" data-testid="btn-manual-invoice" (click)="openAddInvoiceModal()">+ Add Manual Invoice</button>
        </div>
        <div class="data-grid-container">
          <ng-container *ngIf="hasRates; else noRatesTemplate">
            <div class="data-grid-scrollable">
          <table class="data-grid">
            <thead>
              <tr>
                <th class="col-checkbox"><input type="checkbox" (click)="toggleSelectAll($event)" [checked]="isAllSelected" class="company-checkbox" title="Select All"></th>
                <th>Status</th>
                <th>Sent</th>
                <th>Period</th>
                <th>Company</th>
                <th>Country</th>
                <th>Revenue (USD)</th>
                <th>Rem. Balance (USD)</th>
                <th>Actions</th>
              </tr>
              <tr *ngIf="isFilterRowVisible">
                <th></th>
                <th>
                  <select [(ngModel)]="filterStatus" (ngModelChange)="applyFilters()" class="filter-select" (click)="$event.stopPropagation()">
                    <option value="">All</option>
                    <option value="Paid">Paid</option>
                    <option value="Partial">Partial</option>
                    <option value="Not Paid">Not Paid</option>
                    <option value="Canceled">Canceled</option>
                  </select>
                </th>
                <th>
                  <select [(ngModel)]="filterEmailStatus" (ngModelChange)="applyFilters()" class="filter-select" (click)="$event.stopPropagation()">
                    <option value="">All</option>
                    <option value="Sent">Sent</option>
                    <option value="Not Sent">Not Sent</option>
                  </select>
                </th>
                <th></th>
                <th>
                  <input type="text" [(ngModel)]="filterCompany" (ngModelChange)="applyFilters()" class="filter-input" placeholder="Filter..." (click)="$event.stopPropagation()">
                </th>
                <th>
                </th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="isLoadingGrid">
                <td colspan="9" class="text-center loading-row">
                  <div class="loading-content">
                    <div class="spinner spinner-sm"></div>
                    <span>Loading data...</span>
                  </div>
                </td>
              </tr>
              <ng-container *ngIf="!isLoadingGrid">
                <ng-container *ngFor="let row of paginatedGridData">
                <tr (click)="toggleCompanyExpansion(row)" [class.expanded-row]="expandedRowId === row.id" class="data-row" [attr.data-testid]="'invoice-row-' + row.period + '-' + (row.company?.id || row.companyId)">
                  <td><input type="checkbox" [id]="'cb-' + row.id" class="company-checkbox" [checked]="selectedRowIds.has(row.id)" (change)="toggleSelection(row.id)" (click)="$event.stopPropagation()"></td>
                  <td>
                    <span *ngIf="!row.company?.isFeeCollection" data-testid="row-status" class="status" [class.status-paid]="row.status === 'Paid'" [class.status-partial]="row.status === 'Partial'" [class.status-not-paid]="row.status !== 'Paid' && row.status !== 'Partial' && row.status !== 'Canceled'" [class.status-canceled]="row.status === 'Canceled'">
                      {{ row.status }}
                    </span>
                  </td>
                  <td>
                    <span class="status" [class.status-sent]="row.emailStatus === 'Sent'" [class.status-not-sent]="row.emailStatus !== 'Sent'">
                      {{ row.emailStatus }}
                    </span>
                  </td>
                  <td>{{ row.period }}</td>
                  <td [title]="row.company?.id">
                    <ng-container *ngIf="activeBrandName !== 'LFC'; else plainCompany">
                      <a href="javascript:void(0)" class="company-link" (click)="$event.stopPropagation(); openSalesReportModal(row)" title="View Sales Report">
                        {{ row.company.company }}
                      </a>
                    </ng-container>
                    <ng-template #plainCompany>
                      <span>{{ row.company.company }}</span>
                    </ng-template>
                    <span *ngIf="row.company?.isFeeCollection" class="badge-indicator badge-fee-collection">Fee Collection</span>
                    <span *ngIf="row.isManual" class="badge-indicator badge-manual">Manual</span>
                    <span *ngIf="row.isEdited && !row.isManual" class="badge-indicator badge-edited">Edited</span>
                    <span *ngIf="row.isManuallyUnlocked" class="badge-indicator badge-unlocked" title="Unlocked by Superadmin">Unlocked</span>
                  </td>
                  <td>{{ row.country }}</td>
                  <td class="text-right">{{ row.totalRevenueUSD | currency }}</td>
                  <td class="text-right">{{ row.remainingBalanceUSD | currency }}</td>
                  <td class="company-actions text-center">
                    <button class="action-btn view-btn" (click)="$event.stopPropagation(); viewInvoice(row)" title="View Invoice" [disabled]="row.company?.isFeeCollection">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><circle cx="10" cy="14" r="3"></circle><path d="m12.1 16.1 2.9 2.9"></path></svg>
                    </button>
                    <button class="action-btn email-btn" (click)="$event.stopPropagation(); emailSingleInvoice(row)" title="Email Invoice" [disabled]="row.company?.isFeeCollection">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    </button>
                    <button class="action-btn edit-btn" (click)="$event.stopPropagation(); openEditInvoiceModal(row)" title="Edit Invoice" [disabled]="row.company?.isFeeCollection || row.isLocked">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                    </button>
                    <button *ngIf="canDeleteInvoices" class="action-btn delete-btn" data-testid="btn-delete-row" (click)="$event.stopPropagation(); deleteInvoice(row)" title="Delete Invoice" [disabled]="row.company?.isFeeCollection">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="expandedRowId === row.id" class="details-row">
                  <td colspan="9">
                    <div *ngIf="!expandedCompanyTotals" class="details-loading">Loading details...</div>
                    <div *ngIf="expandedCompanyTotals" class="details-container">
                      <div class="invoice-meta-info">
                        <div *ngIf="row.createdAt">
                          <strong>Created:</strong> {{ row.createdAt | date:'medium' }} <span *ngIf="row.createdBy">by {{ row.createdBy }}</span>
                        </div>
                        <div *ngIf="row.updatedAt">
                          <strong>Updated:</strong> {{ row.updatedAt | date:'medium' }} <span *ngIf="row.updatedBy">by {{ row.updatedBy }}</span>
                        </div>
                      </div>
                      <div class="details-grid">
                      <div class="detail-column" *ngIf="!row.company?.isFeeCollection">
                        <h4>Revenue Breakdown</h4>
                        <div class="detail-row" *ngFor="let rate of expandedCompanyTotals.rates">
                          <span>{{ rate.name }}:</span> 
                          <span>{{ (expandedCompanyTotals.revenues[rate.id!] || 0) | currency }}</span>
                        </div>
                        <div class="detail-row total"><span>Total Revenue:</span> <span>{{ expandedCompanyTotals.grandTotalRevenue | currency }}</span></div>
                        <div class="detail-row international-info" *ngIf="expandedCompanyTotals.isInternational">
                          <span>Total Revenue (USD):</span> <span>{{ expandedCompanyTotals.grandTotalRevenueUSD | currency }}</span>
                        </div>
                        <div class="detail-row exchange-rate-info" *ngIf="expandedCompanyTotals.isInternational">
                          Exchange Rate<span *ngIf="expandedCompanyTotals.exchangeRateDate"> (as of {{ expandedCompanyTotals.exchangeRateDate | date:'mediumDate' }})</span>: {{ expandedCompanyTotals.exchangeRate }}
                        </div>
                      </div>
                      <div class="detail-column" *ngIf="row.company?.isFeeCollection" style="grid-column: 1 / -1;">
                        <h4>Fees Collected (By Company)</h4>
                        <table class="data-grid" style="width: auto; min-width: 60%; margin-bottom: 1rem;">
                          <thead>
                            <tr>
                              <th style="padding: 0.75rem 1rem; text-align: left;">Company</th>
                              <th style="padding: 0.75rem 1rem;">Date</th>
                              <th style="padding: 0.75rem 1rem;">Status</th>
                              <th style="padding: 0.75rem 1rem; text-align: right;">Amount</th>
                              <th style="padding: 0.75rem 1rem; text-align: right;">{{ activeBrandName === 'LFC' ? 'LK Fee' : 'Commission' }}</th>
                              <th style="padding: 0.75rem 1rem; text-align: right;">KCEG Fee</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of expandedCompanyTotals.feeCollectionBreakdown">
                              <td style="padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9;">{{ item.companyName }}</td>
                              <td style="padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9; text-align: center;">{{ item.date?.toDate ? (item.date.toDate() | date:'shortDate') : (item.date | date:'shortDate') }}</td>
                              <td style="padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9; text-align: center;">
                                <span class="status" [class.status-paid]="item.status === 'Paid'" [class.status-partial]="item.status === 'Partial'" [class.status-not-paid]="item.status !== 'Paid' && item.status !== 'Partial' && item.status !== 'Canceled'" [class.status-canceled]="item.status === 'Canceled'">
                                  {{ item.status || 'N/A' }}
                                </span>
                              </td>
                              <td style="padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9; text-align: right;">{{ item.amount | currency }}</td>
                              <td style="padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9; text-align: right;">
                                <span *ngIf="item.lfcFee">{{ item.lfcFee | currency }}</span>
                                <span *ngIf="!item.lfcFee" style="color: #cbd5e1;">-</span>
                              </td>
                              <td style="padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9; text-align: right;">
                                <span *ngIf="item.kcegFee">{{ item.kcegFee | currency }}</span>
                                <span *ngIf="!item.kcegFee" style="color: #cbd5e1;">-</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="detail-row total" style="width: auto; min-width: 60%; max-width: 800px;">
                          <span>Total Fees Collected:</span> 
                          <span>
                            <span style="display: inline-block; width: 80px; text-align: right;">{{ expandedCompanyTotals.grandTotalRevenue | currency }}</span>
                            <span style="display: inline-block; width: 140px; margin-left: 8px; text-align: right;">{{ activeBrandName === 'LFC' ? 'LK' : 'Commission' }}: {{ expandedCompanyTotals.totalLfcFee | currency }}</span>
                            <span style="display: inline-block; width: 130px; margin-left: 8px; text-align: right;">KCEG: {{ expandedCompanyTotals.totalKcegFee | currency }}</span>
                          </span>
                        </div>
                        <div class="detail-row international-info" *ngIf="expandedCompanyTotals.isInternational" style="width: auto; min-width: 60%; max-width: 800px;">
                          <span>Total Fees Collected (USD):</span> 
                          <span>
                            <span style="display: inline-block; width: 80px; text-align: right;">{{ expandedCompanyTotals.grandTotalRevenueUSD | currency }}</span>
                            <span style="display: inline-block; width: 140px; margin-left: 8px; text-align: right;">{{ activeBrandName === 'LFC' ? 'LK' : 'Commission' }}: {{ expandedCompanyTotals.totalLfcFeeUSD | currency }}</span>
                            <span style="display: inline-block; width: 130px; margin-left: 8px; text-align: right;">KCEG: {{ expandedCompanyTotals.totalKcegFeeUSD | currency }}</span>
                          </span>
                        </div>
                        <div class="detail-row exchange-rate-info" *ngIf="expandedCompanyTotals.isInternational" style="width: auto; min-width: 60%; max-width: 800px;">
                          Exchange Rate<span *ngIf="expandedCompanyTotals.exchangeRateDate"> (as of {{ expandedCompanyTotals.exchangeRateDate | date:'mediumDate' }})</span>: {{ expandedCompanyTotals.exchangeRate }}
                        </div>
                      </div>
                      <div class="detail-column" *ngIf="!row.company?.isFeeCollection">
                        <h4>Fee Breakdown</h4>
                        <div class="detail-row" *ngFor="let rate of expandedCompanyTotals.rates">
                          <span>{{ rate.name }} ({{ rate.rate }}%):</span> 
                          <span>
                            <span style="display: inline-block; width: 80px; text-align: right;">{{ (expandedCompanyTotals.fees[rate.id!] || 0) | currency }}</span>
                            <span style="color: #64748b; font-size: 0.9em; margin-left: 8px; display: inline-block; width: 140px; text-align: right;">{{ activeBrandName === 'LFC' ? 'LK' : 'Commission' }}: {{ (expandedCompanyTotals.lfcFees[rate.id!] || 0) | currency }} ({{ expandedCompanyTotals.lfcRatesMap[rate.id!] }}%)</span>
                            <span style="color: #64748b; font-size: 0.9em; margin-left: 8px; display: inline-block; width: 130px; text-align: right;">KCEG: {{ (expandedCompanyTotals.kcegFees[rate.id!] || 0) | currency }} ({{ expandedCompanyTotals.kcegRatesMap[rate.id!] }}%)</span>
                          </span>
                        </div>
                        <div class="detail-row total">
                          <span>Total Fees:</span> 
                          <span>
                            <span style="display: inline-block; width: 80px; text-align: right;">{{ expandedCompanyTotals.totalFee | currency }}</span>
                            <span style="color: #64748b; font-size: 0.9em; margin-left: 8px; display: inline-block; width: 140px; text-align: right;">{{ activeBrandName === 'LFC' ? 'LK' : 'Commission' }}: {{ expandedCompanyTotals.totalLfcFee | currency }}</span>
                            <span style="color: #64748b; font-size: 0.9em; margin-left: 8px; display: inline-block; width: 130px; text-align: right;">KCEG: {{ expandedCompanyTotals.totalKcegFee | currency }}</span>
                          </span>
                        </div>
                        <div class="detail-row international-info" *ngIf="expandedCompanyTotals.isInternational">
                          <span>Total Fees (USD):</span> 
                          <span>
                            <span style="display: inline-block; width: 80px; text-align: right;">{{ expandedCompanyTotals.totalFeeUSD | currency }}</span>
                            <span style="display: inline-block; width: 140px; margin-left: 8px; text-align: right;">{{ activeBrandName === 'LFC' ? 'LK' : 'Commission' }}: {{ expandedCompanyTotals.totalLfcFeeUSD | currency }}</span>
                            <span style="display: inline-block; width: 130px; margin-left: 8px; text-align: right;">KCEG: {{ expandedCompanyTotals.totalKcegFeeUSD | currency }}</span>
                          </span>
                        </div>
                      </div>
                      <div class="detail-column summary" *ngIf="!row.company?.isFeeCollection">
                        <h4>Summary</h4>
                        <div class="detail-row beginning-balance-row">
                          <span>Beginning Balance:</span> 
                          <div *ngIf="!expandedCompanyTotals.isEditingBeginningBalance" class="balance-display">
                            <!-- <span *ngIf="expandedCompanyTotals.isOverridden" class="badge-indicator badge-overridden">Overridden</span>
                            <button class="action-btn edit-btn" style="padding: 1px 6px; font-size: 0.7rem; min-width: auto;" (click)="startEditingBeginningBalance()">Edit</button> -->
                            <span *ngIf="(row.displayAmountPaid - row.amountPaid) > 0.01" style="font-size: 0.85em; color: #64748b; margin-left: 4px; font-style: italic;">
                              ({{ (row.displayAmountPaid - row.amountPaid) | currency }} applied to previous periods)
                            </span>
                            <span data-testid="detail-beginning-balance">{{ expandedCompanyTotals.beginningBalance | currency }}</span>
                          </div>
                          <div *ngIf="expandedCompanyTotals.isEditingBeginningBalance" class="balance-edit">
                            <button class="action-btn mini-btn cancel-edit" (click)="cancelEditingBeginningBalance()">Cancel</button>
                            <button class="action-btn save-btn mini-btn" (click)="saveBeginningBalance()">Save</button>
                            <input type="number" [(ngModel)]="expandedCompanyTotals.newBeginningBalance" class="table-input mini-input">
                          </div>
                        </div>
                        <div class="detail-row"><span>Total Charges:</span> <span data-testid="detail-total-fee">{{ expandedCompanyTotals.totalFee | currency }}</span></div>
                        <div class="detail-row grand-total"><span>Total Due:</span> <span data-testid="detail-total-due">{{ expandedCompanyTotals.totalDue | currency }}</span></div>
                        
                        <div class="detail-row amount-paid-row">
                          <span class="label-strong">Amount Paid:</span>
                          <div style="display: flex; align-items: center; justify-content: flex-end;">
                            <span *ngIf="row.status !== 'Partial'" class="value-strong" data-testid="detail-amount-paid">{{ row.displayAmountPaid | currency }}</span>
                            <button *ngIf="expandedCompanyTotals.beginningBalance > 0.01 || (row.displayAmountPaid - row.amountPaid) > 0.01" class="action-btn utility-btn mini-btn" style="margin-left: 10px; margin-right: 10px; display: inline-flex; align-items: center;" [disabled]="loadingDistributionId === row.id" (click)="viewDistribution(row); $event.stopPropagation()">
                              <div *ngIf="loadingDistributionId === row.id" class="spinner-mini"></div>
                              {{ loadingDistributionId === row.id ? 'Loading...' : 'View Distribution' }}
                            </button>
                            <div *ngIf="updatingPartialId === row.id" class="spinner-mini" style="margin-right: 8px;"></div>
                            <input *ngIf="row.status === 'Partial'" type="number" [(ngModel)]="row.displayAmountPaid" (change)="updateAmountPaid(row)" (click)="$event.stopPropagation()" class="partial-amount-input" data-testid="partial-amount-input" [disabled]="row.isLocked || updatingPartialId === row.id">
                          </div>
                        </div>

                        <div class="detail-row" *ngIf="expandedCompanyTotals.beginningBalance > 0.01 || (row.displayAmountPaid - row.amountPaid) > 0.01" style="margin-top: 4px;">
                          <span class="label-strong" style="font-size: 0.85rem; color: #64748b;">Amount applied this period:</span>
                          <span class="value-strong" style="font-size: 0.85rem; color: #64748b;">{{ row.amountPaid | currency }}</span>
                        </div>

                        <div class="detail-row" *ngIf="row.appliedFrom && row.appliedFrom.length > 0" style="margin-top: 4px;">
                          <span class="label-strong" style="font-size: 0.85rem; color: #64748b;">Applied from:</span>
                          <div style="display: flex; flex-direction: column; align-items: flex-end;">
                            <span *ngFor="let from of row.appliedFrom" class="value-strong" style="font-size: 0.85rem; color: #64748b; font-style: italic;">
                              {{ from.period }} ({{ from.amount | currency }})
                            </span>
                          </div>
                        </div>

                        <div class="detail-row remaining-balance-row">
                          <div class="label-with-action">
                            <span class="label-strong">Remaining Balance:</span>
                            <button class="action-btn utility-btn mini-btn history-btn" data-testid="btn-history" (click)="viewHistory(row); $event.stopPropagation()" title="View History">
                              History
                            </button>
                          </div>
                          <span class="value-strong" data-testid="detail-remaining-balance">{{ row.remainingBalance | currency }}</span>
                        </div>
                        <div class="detail-row international-info" *ngIf="expandedCompanyTotals.isInternational">
                          <span>Remaining Balance (USD):</span> <span>{{ expandedCompanyTotals.remainingBalanceUSD | currency }}</span>
                        </div>
                        <div class="status-actions" *ngIf="!row.company?.isFeeCollection">
                          <ng-container *ngIf="!row.isUpdatingStatus">
                            <button (click)="updateInvoiceStatus(row, 'Paid'); $event.stopPropagation()" class="status-btn paid" data-testid="btn-paid" [class.active]="row.status === 'Paid'" [disabled]="row.status === 'Canceled' || row.isLocked">Paid</button>
                            <button (click)="updateInvoiceStatus(row, 'Partial'); $event.stopPropagation()" class="status-btn partial" data-testid="btn-partial" [class.active]="row.status === 'Partial'" [disabled]="row.status === 'Canceled' || row.isLocked">Partial</button>
                            <button (click)="updateInvoiceStatus(row, 'Not Paid'); $event.stopPropagation()" class="status-btn not-paid" data-testid="btn-not-paid" [class.active]="row.status === 'Not Paid'" [disabled]="row.status === 'Canceled' || row.isLocked">Not Paid</button>
                            <button (click)="toggleCancelStatus(row); $event.stopPropagation()" 
                                     class="status-btn cancel" 
                                     [class.active]="row.status === 'Canceled'"
                                     [disabled]="row.isLocked">
                              {{ row.status === 'Canceled' ? 'Uncancel' : 'Cancel' }}
                            </button>
                          </ng-container>
                          <div *ngIf="row.isUpdatingStatus" style="display: flex; align-items: center; justify-content: center; padding: 4px 8px; border-radius: 4px; background-color: #f3f4f6; width: 100%;">
                            <div class="spinner-mini"></div>
                            <span style="margin-left: 8px; font-size: 0.85rem; color: #4b5563; font-weight: 500;">Updating...</span>
                          </div>
                          <div *ngIf="row.isLocked && !row.isUpdatingStatus" class="lock-indicator-wrapper">
                            <span class="lock-indicator locked" title="Locked by a future payment">🔒 Locked</span>
                            <button *ngIf="isSuperAdmin" 
                                    class="action-btn unlock-row-btn" 
                                    (click)="toggleUnlockInvoiceRow(row); $event.stopPropagation()" 
                                    title="Unlock this invoice to allow updating paid status">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="btn-icon"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path></svg>
                              Unlock
                            </button>
                          </div>
                          <div *ngIf="row.isManuallyUnlocked && !row.isUpdatingStatus" class="lock-indicator-wrapper">
                            <span class="lock-indicator unlocked" title="Unlocked by Superadmin (future payment lock overridden)">🔓 Unlocked</span>
                            <button *ngIf="isSuperAdmin" 
                                    class="action-btn relock-row-btn" 
                                    (click)="toggleUnlockInvoiceRow(row); $event.stopPropagation()" 
                                    title="Re-lock this invoice">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="btn-icon"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                              Re-lock
                            </button>
                          </div>
                        </div>

                        <div class="detail-row email-info" *ngIf="row.emailSentAt">
                          <span>Sent Date:</span> <span>{{ row.emailSentAt | date:'mediumDate' }}</span>
                        </div>
                        <div class="detail-row email-recipients" *ngIf="row.emailRecipients">
                          <span>Sent to:</span>
                          <div class="recipients-list">
                            <span [title]="row.emailRecipients">{{ getRecipientSummary(row.emailRecipients).first }}</span>
                            <button *ngIf="getRecipientSummary(row.emailRecipients).count > 0" (click)="openRecipientsModal(row.emailRecipients); $event.stopPropagation()" class="more-recipients-btn">
                              +{{ getRecipientSummary(row.emailRecipients).count }} more
                            </button>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </td>
                </tr>
                </ng-container>
                <tr *ngIf="filteredGridData.length === 0">
                  <td colspan="9" class="empty-state text-center">No data found for this period. Import data or manually add invoices.</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          </div>
          <div class="pagination-controls" *ngIf="filteredGridData.length > 0">
            <div class="page-size-selector">
              <span>Rows per page:</span>
              <select [(ngModel)]="pageSize" (change)="onPageSizeChange()" class="page-size-select">
                <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
              </select>
            </div>
            <div class="page-navigation">
              <span>{{ paginationRange }}</span>
              <button class="pagination-btn" [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">&lt;</button>
              <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">&gt;</button>
            </div>
          </div>
          </ng-container>
          <ng-template #noRatesTemplate>
            <div class="empty-state no-rates-message">Please set the rates to show invoices</div>
          </ng-template>
        </div>
        <div class="grid-actions" *ngIf="gridData.length > 0">
          <button class="action-btn save-btn" (click)="saveSelectedInvoices()" [disabled]="selectedRowIds.size === 0 || isSavingPDFs">
            {{ isSavingPDFs ? 'Saving...' : 'Save Selected Invoices' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Import Tab -->
    <div *ngIf="activeTab === 'import'">
      <div class="selection-container">
        <label for="period-select-import">Select Period</label>
        <select id="period-select-import" [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange($event)" class="period-select" [disabled]="isImporting">
          <option [ngValue]="undefined">-- Select Year/Month --</option>
          <option *ngFor="let period of periods" [value]="period">{{ period }}</option>
        </select>

        <div class="uploader-container" *ngIf="selectedPeriod && showUploader">
      <app-excel-uploader 
        [selectedPeriod]="selectedPeriod" 
        [isImporting]="isImporting" 
        [importProgress]="importProgress"
        (fileSelected)="onFileSelected($any($event))">
      </app-excel-uploader>
      <div *ngIf="isImporting" class="importing-status">
        <span>Importing Excel file... Please do not navigate away.</span>
        <button (click)="cancelImport()" class="cancel-import-btn">Cancel</button>
      </div>      
      <div *ngIf="importSuccessMessage" class="status-message success">
        {{ importSuccessMessage }}
      </div>
    </div>
        <app-upload-history 
          collectionName="invoice_upload_history" 
          class="upload-history-comp"
          (delete)="onDeleteHistory($event)">
        </app-upload-history>
      </div>
    </div>

</div>

<!-- Hidden container for PDF generation -->
<!-- <div style="position: absolute; top: 0; left: 0; width: 750px; z-index: -1000; visibility: visible;">
  <div id="pdf-content" class="invoice-modal" style="position: static; transform: none; width: 100%; max-width: none; height: auto; max-height: none; overflow: visible; box-shadow: none; margin: 0; background: white; padding: 40px; display: block;"> -->
<div class="print-container">
  <div id="pdf-content" class="invoice-modal">    
    <div class="invoice-header">
      <div class="company-brand">
        <h1>INVOICE</h1>
        <p>{{ activeBrandName === 'LFC' ? 'LFC Franchise Inc.' : 'KCE Group' }}</p>
        <p>6980 Beach Blvd., H-110, Buena Park, CA 90621 (714) 349-8856</p>
      </div>
      <div class="invoice-meta">
        <div class="meta-group">
          <label>Invoice #</label>
          <span>{{ invoiceNumber }}</span>
        </div>
        <div class="meta-group">
          <label>Date</label>
          <span>{{ currentDate | date:'mediumDate' }}</span>
        </div>
        <div class="meta-group">
          <label>Period</label>
          <span>{{ selectedCompany?.statementPeriod }}</span>
        </div>
      </div>
    </div>

    <div class="invoice-body invoice-body-print">
      <div class="bill-to">
        <h3>Bill To:</h3>
        <p><strong>{{ selectedCompany?.company }}</strong></p>
        <p>{{ selectedCompany?.pocName }}</p>
        <p>{{ selectedCompany?.email }}</p>
        <p>{{ selectedCompany?.phone }}</p>
      </div>

      <div *ngIf="invoiceTotals.isInternational" class="international-note">
        Below amounts are in {{ invoiceTotals.country }} currency.
      </div>

      <table class="invoice-table">
        <thead>
          <tr>
            <th>Store Location</th>
            <th class="text-center" *ngFor="let rate of currentViewRates">{{ rate.name }} Revenue</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of invoiceItems" class="print-row">
            <td><div class="print-cell-div">{{ item.storeName }}</div></td>
            <td class="text-center" *ngFor="let rate of currentViewRates"><div class="print-cell-div">{{ (item.revenues[rate.id!] || 0) | currency }}</div></td>
          </tr>
          <tr *ngIf="invoiceItems.length === 0">
            <td colspan="5" class="text-center empty-invoice-items">No sales data found for this period.</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="footer-header-row">
            <td>Grand Total</td>
            <td class="text-center" *ngFor="let rate of currentViewRates">{{ (invoiceTotals.revenues[rate.id!] || 0) | currency }}</td>
          </tr>
          <tr>
            <td>Total Revenue</td>
            <td [attr.colspan]="currentViewRates.length" class="text-center total-revenue-cell"><strong>{{ invoiceTotals.grandTotalRevenue | currency }}</strong></td>
          </tr>
          <tr>
            <td>Applied SMRS Fee Rate</td>
            <td class="text-center" *ngFor="let rate of currentViewRates">{{ rate.rate }}%</td>
          </tr>
          <tr>
            <td>SMRS Fee</td>
            <td class="text-center" *ngFor="let rate of currentViewRates">{{ (invoiceTotals.fees[rate.id!] || 0) | currency }}</td>
          </tr>
          <tr>
            <td [attr.colspan]="currentViewRates.length" class="text-right beginning-balance-cell">Beginning Balance Forward</td>
            <td class="text-right beginning-balance-cell">{{ invoiceTotals.beginningBalance | currency }}</td>
          </tr>
          <tr>
            <td [attr.colspan]="currentViewRates.length" class="text-right">Total SMRS Fee Charges</td>
            <td class="text-right">{{ invoiceTotals.totalFee | currency }}</td>
          </tr>
          <tr class="total-row">
            <td [attr.colspan]="currentViewRates.length" class="text-right">Total SMRS Fee Due</td>
            <td class="text-right total-due-cell">{{ invoiceTotals.totalDue | currency }}</td>
          </tr>
          <tr *ngIf="invoiceTotals.isInternational">
            <td [attr.colspan]="currentViewRates.length" class="text-right">Total SMRS Fee Due in USD (Ex. Rate<span *ngIf="invoiceTotals.exchangeRateDate"> (as of {{ invoiceTotals.exchangeRateDate | date:'mediumDate' }})</span>: {{ invoiceTotals.exchangeRate }})</td>
            <td class="text-right total-due-cell">{{ invoiceTotals.totalDueUSD | currency:'USD' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<!-- Invoice Modal -->
<div class="modal-overlay" *ngIf="isInvoiceModalOpen" (click)="closeInvoiceModal()">
  <div class="invoice-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Invoice {{ selectedCompany?.invoiceNumber }}</h2>
      <div class="header-actions">
        <button class="action-btn view-btn" (click)="printInvoice(selectedCompany)">Save to PDF</button>
        <button class="close-btn-static" (click)="closeInvoiceModal()">&times;</button>
      </div>
    </div>
    <div *ngIf="isLoadingInvoice" class="loading-overlay">
      <div class="spinner spinner-mb"></div>
      <p>Loading Invoice Data...</p>
    </div>

    <ng-container *ngIf="!isLoadingInvoice">
    <div class="invoice-header">
      <div class="company-brand">
        <h1>INVOICE</h1>
        <p>{{ activeBrandName === 'LFC' ? 'LFC Franchise Inc.' : 'KCE Group' }}</p>
        <p>6980 Beach Blvd., H-110, Buena Park, CA 90621 (714) 349-8856</p>
      </div>
      <div class="invoice-meta">
        <div class="meta-group">
          <label>Invoice #</label>
          <span>{{ invoiceNumber }}</span>
        </div>
        <div class="meta-group">
          <label>Date</label>
          <span>{{ currentDate | date:'mediumDate' }}</span>
        </div>
        <div class="meta-group">
          <label>Period</label>
          <span>{{ selectedCompany?.statementPeriod }}</span>
        </div>
      </div>
    </div>

    <div class="invoice-body">
      <div class="bill-to">
        <h3>Bill To:</h3>
        <p><strong>{{ selectedCompany?.company }}</strong></p>
        <p>{{ selectedCompany?.pocName }}</p>
        <p>{{ selectedCompany?.email }}</p>
        <p>{{ selectedCompany?.phone }}</p>
      </div>

      <div *ngIf="invoiceTotals.isInternational" class="international-note">
        Below amounts are in {{ invoiceTotals.country }} currency.
      </div>

      <table class="invoice-table">
        <thead>
          <tr>
            <th>Store Location</th>
            <th class="text-center" *ngFor="let rate of currentViewRates">{{ rate.name }} Revenue</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of invoiceItems" class="print-row">
            <td>{{ item.storeName }}</td>
            <td class="text-center" *ngFor="let rate of currentViewRates">{{ (item.revenues[rate.id!] || 0) | currency }}</td>
          </tr>
          <tr *ngIf="invoiceItems.length === 0">
            <td colspan="5" class="text-center empty-invoice-items">No sales data found for this period.</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="footer-header-row">
            <td>Grand Total</td>
            <td class="text-center" *ngFor="let rate of currentViewRates">{{ (invoiceTotals.revenues[rate.id!] || 0) | currency }}</td>
          </tr>
          <tr>
            <td>Total Revenue</td>
            <td [attr.colspan]="currentViewRates.length" class="text-center total-revenue-cell"><strong>{{ invoiceTotals.grandTotalRevenue | currency }}</strong></td>
          </tr>
          <tr>
            <td>Applied SMRS Fee Rate</td>
            <td class="text-center" *ngFor="let rate of currentViewRates">{{ rate.rate }}%</td>
          </tr>
          <tr>
            <td>SMRS Fee</td>
            <td class="text-center" *ngFor="let rate of currentViewRates">{{ (invoiceTotals.fees[rate.id!] || 0) | currency }}</td>
          </tr>
          <tr>
            <td [attr.colspan]="currentViewRates.length" class="text-right beginning-balance-cell">Beginning Balance Forward</td>
            <td class="text-right beginning-balance-cell">{{ invoiceTotals.beginningBalance | currency }}</td>
          </tr>
          <tr>
            <td [attr.colspan]="currentViewRates.length" class="text-right">Total SMRS Fee Charges</td>
            <td class="text-right">{{ invoiceTotals.totalFee | currency }}</td>
          </tr>
          <tr class="total-row">
            <td [attr.colspan]="currentViewRates.length" class="text-right">Total SMRS Fee Due</td>
            <td class="text-right total-due-cell">{{ invoiceTotals.totalDue | currency }}</td>
          </tr>
          <tr *ngIf="invoiceTotals.isInternational">
            <td [attr.colspan]="currentViewRates.length" class="text-right">Total SMRS Fee Due in USD (Ex. Rate<span *ngIf="invoiceTotals.exchangeRateDate"> (as of {{ invoiceTotals.exchangeRateDate | date:'mediumDate' }})</span>: {{ invoiceTotals.exchangeRate }})</td>
            <td class="text-right total-due-cell">{{ invoiceTotals.totalDueUSD | currency:'USD' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="invoice-footer">
      <p>Thank you for your business!</p>
    </div>
    </ng-container>
  </div>
</div>

<!-- Loading Overlay for Actions (Email/Save) -->
<div class="modal-overlay overlay-z2000" *ngIf="isSavingPDFs">
  <div class="processing-box">
    <div class="spinner spinner-mb0"></div>
    <p class="processing-text">Processing...</p>
  </div>
</div>

<!-- Duplicate Warning Modal -->
<div class="modal-overlay" *ngIf="duplicateWarningData">
  <div class="invoice-modal duplicate-modal">
    <div class="invoice-header duplicate-header">
      <h2 class="duplicate-title">Duplicate Import Detected</h2>
    </div>
    
    <div class="invoice-body">
      <p class="duplicate-text">It looks like you already imported this file with this file name for this period. Please see below:</p>
      
      <div class="duplicate-info-box">
        <div class="duplicate-grid">
          <div><strong>File Name:</strong></div>
          <div>{{ duplicateWarningData.existingRecord.fileName }}</div>
          <div><strong>Uploaded Date:</strong></div>
          <div>{{ duplicateWarningData.existingRecord.uploadedAt | date:'medium' }}</div>
          <div><strong>Records:</strong></div>
          <div>{{ duplicateWarningData.existingRecord.recordCount }}</div>
        </div>
      </div>

      <p class="duplicate-prompt">Would you like to import again? This will clear out the previous import that you've done above and reimport.</p>
      
      <div class="duplicate-actions">
        <button class="action-btn btn-cancel-duplicate" (click)="cancelDuplicate()">Cancel</button>
        <button class="action-btn btn-proceed-duplicate" (click)="proceedWithDuplicate()">Proceed & Re-import</button>
      </div>
    </div>
  </div>
</div>

<!-- Historical Period Import Confirmation Modal (Superadmin Only) -->
<div class="modal-overlay overlay-z2000" *ngIf="historicalImportConfirmationData" (click)="cancelHistoricalImport()">
  <div class="invoice-modal historical-import-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Historical Period Import Review</h2>
      <button class="close-btn-static" (click)="cancelHistoricalImport()">&times;</button>
    </div>
    
    <div class="invoice-body">
      <div class="historical-warning-banner">
        <div class="warning-badge-icon">⚠️</div>
        <div class="warning-badge-content">
          <strong>Important Ledger Impact Notice</strong>
          <p>
            You are importing data for an earlier billing period (<strong>{{ historicalImportConfirmationData.period }}</strong>).
            Chronologically subsequent period balances will be automatically recalculated forward according to FIFO ledger rules.
          </p>
        </div>
      </div>

      <div class="historical-summary-box">
        <div class="historical-grid">
          <div class="summary-label">Target Brand:</div>
          <div class="summary-value"><strong>{{ historicalImportConfirmationData.brandName }}</strong></div>

          <div class="summary-label">Selected Period:</div>
          <div class="summary-value"><span class="period-tag">{{ historicalImportConfirmationData.period }}</span></div>

          <div class="summary-label">File Name:</div>
          <div class="summary-value">{{ historicalImportConfirmationData.file.name }}</div>

          <div class="summary-label">Companies Detected:</div>
          <div class="summary-value">
            <strong>{{ historicalImportConfirmationData.detectedCompanies.length }} company(ies)</strong>
            <div class="detected-companies-list" *ngIf="historicalImportConfirmationData.detectedCompanies.length > 0">
              <span *ngFor="let cName of historicalImportConfirmationData.detectedCompanies" class="company-tag">{{ cName }}</span>
            </div>
          </div>

          <div class="summary-label">Later Periods Recalculated:</div>
          <div class="summary-value">
            <div class="future-periods-tags">
              <span *ngFor="let p of historicalImportConfirmationData.affectedFuturePeriods" class="future-period-tag">{{ p }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="historical-invariants-note">
        <ul>
          <li><strong>Recorded Payments Preserved:</strong> Historical <code>amountPaid</code> and <code>actualAmountPaid</code> records will remain intact and will NOT be overwritten.</li>
          <li><strong>Forward Balance Chaining:</strong> Beginning balances, total due, remaining balances, and payment statuses for later months will recalculate forward.</li>
          <li><strong>Zero Synthetic Invoices:</strong> Unaffected companies and calendar gaps without aggregations will remain untouched.</li>
        </ul>
      </div>

      <div class="duplicate-actions" style="margin-top: 24px;">
        <button class="action-btn cancel-edit" (click)="cancelHistoricalImport()">Cancel</button>
        <button class="action-btn save-btn" (click)="proceedWithHistoricalImport()">
          Confirm & Recalculate Ledgers
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Generate SMRS Invoices Review Modal (KAN-284) -->
<div class="modal-overlay overlay-z2000" *ngIf="isGenerationPreviewOpen" (click)="cancelGenerationPreview()">
  <div class="invoice-modal generation-modal" role="dialog" aria-modal="true" aria-labelledby="generation-title" data-testid="generation-preview" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2 id="generation-title">Review SMRS Invoice Generation</h2>
      <button class="close-btn-static" aria-label="Close" (click)="cancelGenerationPreview()" [disabled]="isGeneratingInvoices">&times;</button>
    </div>

    <div class="invoice-body">
      <div class="historical-summary-box">
        <div class="historical-grid">
          <div class="summary-label">Brand:</div>
          <div class="summary-value"><strong>{{ activeBrandName }}</strong></div>
          <div class="summary-label">Period:</div>
          <div class="summary-value"><span class="period-tag">{{ selectedPeriod }}</span></div>
        </div>
      </div>

      <p class="generation-note">
        Only invoices generated from device reports are regenerated. Manual invoices, invoices edited on this page, and canceled invoices are kept unchanged. Recorded payments are never changed.
      </p>

      <div class="generation-loading" *ngIf="isPlanningGeneration">
        <span class="spinner-inline"></span> Building preview…
      </div>

      <div class="generation-alert generation-alert-error" *ngIf="generationPlanError" role="alert">{{ generationPlanError }}</div>

      <div class="generation-alert generation-alert-stale" *ngIf="isGenerationStale" role="alert" data-testid="generation-stale">
        Source data changed since this preview was built. Refresh the preview before applying.
      </div>

      <div class="data-grid-scrollable" *ngIf="generationPlan && !isPlanningGeneration">
        <table class="data-grid generation-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Action</th>
              <th class="text-right">Revenue</th>
              <th class="text-right">Fee</th>
              <th class="text-right">Amount Paid</th>
              <th class="text-right">Remaining</th>
              <th>Status</th>
              <th>Later Periods</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let c of changingGenerationCompanies">
              <tr [attr.data-testid]="'generation-row-' + c.companyId">
                <td>
                  {{ c.companyName }}
                  <span class="badge-indicator badge-edited" *ngIf="c.emailed" title="This invoice was already emailed to the customer">Already sent to customer</span>
                </td>
                <td>
                  <span class="generation-badge"
                        [class.gen-new]="c.classification === 'new'"
                        [class.gen-refresh]="c.classification === 'refresh'"
                        [class.gen-partial]="c.missingDevices.length > 0">{{ generationLabel(c) }}</span>
                  <button type="button" class="generation-missing-toggle" *ngIf="c.missingDevices.length > 0"
                          [attr.aria-expanded]="expandedGenerationRows.has(c.companyId)"
                          (click)="toggleGenerationRow(c.companyId)">
                    {{ c.missingDevices.length }} device(s) missing reports
                  </button>
                </td>
                <td class="text-right"><span class="gen-before" *ngIf="c.before">{{ c.before.totalRevenue | currency }} → </span>{{ c.after?.totalRevenue | currency }}</td>
                <td class="text-right"><span class="gen-before" *ngIf="c.before">{{ c.before.totalFee | currency }} → </span>{{ c.after?.totalFee | currency }}</td>
                <td class="text-right">{{ c.after?.amountPaid | currency }}</td>
                <td class="text-right"><span class="gen-before" *ngIf="c.before">{{ c.before.remainingBalance | currency }} → </span>{{ c.after?.remainingBalance | currency }}</td>
                <td><span class="gen-before" *ngIf="c.before && c.before.status !== c.after?.status">{{ c.before.status }} → </span>{{ c.after?.status }}</td>
                <td>
                  <ng-container *ngIf="c.forward.affectedPeriods.length > 0; else noForward">
                    {{ c.forward.affectedPeriods.length }} period(s); latest balance
                    {{ c.forward.latestRemainingChange >= 0 ? '+' : '' }}{{ c.forward.latestRemainingChange | currency }}
                  </ng-container>
                  <ng-template #noForward>None</ng-template>
                </td>
              </tr>
              <tr class="generation-missing-row" *ngIf="expandedGenerationRows.has(c.companyId)">
                <td colspan="8">
                  <ul class="generation-missing-list">
                    <li *ngFor="let m of c.missingDevices">{{ m.deviceName }} ({{ m.deviceId }}) at {{ m.storeName }}: no report, counted as $0</li>
                  </ul>
                </td>
              </tr>
            </ng-container>
            <tr *ngIf="changingGenerationCompanies.length === 0">
              <td colspan="8" class="text-center" data-testid="generation-no-changes">No invoices will change.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="generation-unchanged-note" *ngIf="generationPlan && !isPlanningGeneration && unchangedGenerationCount > 0" data-testid="generation-unchanged-count">
        {{ unchangedGenerationCount }} other compan{{ unchangedGenerationCount === 1 ? 'y has' : 'ies have' }} no changes (manual, canceled or already up to date) and {{ unchangedGenerationCount === 1 ? 'is' : 'are' }} not listed.
      </p>

      <div class="duplicate-actions generation-actions">
        <button class="action-btn cancel-edit" (click)="cancelGenerationPreview()" [disabled]="isGeneratingInvoices">Cancel</button>
        <button class="action-btn cancel-edit" data-testid="btn-generation-refresh" (click)="refreshGenerationPreview()" [disabled]="isPlanningGeneration || isGeneratingInvoices">Refresh Preview</button>
        <button class="action-btn save-btn" data-testid="btn-generation-confirm" (click)="confirmGeneration()" [disabled]="!canConfirmGeneration">
          <span *ngIf="isGeneratingInvoices" class="spinner-inline"></span>
          {{ isGeneratingInvoices ? 'Generating…' : 'Confirm & Generate' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Generate SMRS Invoices Result Modal (KAN-284) -->
<div class="modal-overlay overlay-z2000" *ngIf="generationResult" (click)="closeGenerationResult()">
  <div class="invoice-modal generation-modal" role="dialog" aria-modal="true" aria-labelledby="generation-result-title" data-testid="generation-result" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2 id="generation-result-title">Generation Results</h2>
      <button class="close-btn-static" aria-label="Close" (click)="closeGenerationResult()">&times;</button>
    </div>
    <div class="invoice-body">
      <div class="generation-counts">
        <span class="company-tag">Created: {{ generationResult.counts.created }}</span>
        <span class="company-tag">Refreshed: {{ generationResult.counts.refreshed }}</span>
        <span class="company-tag">Partial: {{ generationResult.counts.partial }}</span>
        <span class="company-tag" [class.generation-failed-tag]="generationResult.counts.failed > 0">Failed: {{ generationResult.counts.failed }}</span>
      </div>
      <div class="data-grid-scrollable">
        <table class="data-grid generation-table">
          <thead>
            <tr><th>Company</th><th>Outcome</th><th>Details</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of generationResult.outcomes" [attr.data-testid]="'generation-outcome-' + o.companyId">
              <td>{{ o.companyName }}</td>
              <td><span class="generation-badge" [class.gen-failed]="o.outcome === 'failed'" [class.gen-partial]="o.partial">{{ generationOutcomeLabel(o.outcome) }}</span></td>
              <td>
                {{ o.reason }}
                <ul class="generation-missing-list" *ngIf="o.missingDevices.length > 0">
                  <li *ngFor="let m of o.missingDevices">{{ m.deviceName }} ({{ m.deviceId }}) at {{ m.storeName }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="generation-unchanged-note" *ngIf="skippedGenerationCount > 0" data-testid="generation-result-skipped-count">
        {{ skippedGenerationCount }} other compan{{ skippedGenerationCount === 1 ? 'y was' : 'ies were' }} not regenerated (manual, canceled or already up to date).
      </p>
      <div class="duplicate-actions generation-actions">
        <button class="action-btn save-btn" (click)="closeGenerationResult()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Recipients Modal -->
<div class="modal-overlay" *ngIf="isRecipientsModalOpen" (click)="closeRecipientsModal()">
  <div class="invoice-modal recipients-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Email Recipients</h2>
      <button class="close-btn-static" (click)="closeRecipientsModal()">&times;</button>
    </div>
    <div class="invoice-body recipients-body">
      <ul class="recipients-ul">
        <li *ngFor="let email of currentRecipients" class="recipient-li">
          {{ email }}
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Manual Invoice Modal -->
<div class="modal-overlay" *ngIf="isManualModalOpen" (click)="closeManualModal()">
  <div class="invoice-modal manual-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>{{ isManualEditMode ? 'Edit' : 'Add' }} Invoice</h2>
      <button class="close-btn-static" (click)="closeManualModal()">&times;</button>
    </div>
    
    <div class="invoice-body">
      <div class="form-row">
        <div class="form-group">
          <label>Period</label>
          <select [(ngModel)]="manualInvoiceData.period" (ngModelChange)="onManualPeriodChange()" class="form-control" [disabled]="isManualEditMode">
            <option [ngValue]="undefined" disabled selected>Select Period</option>
            <option *ngFor="let p of periods" [value]="p">{{ p }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Company</label>
          <select [(ngModel)]="manualInvoiceData.companyId" (change)="onManualCompanyChange()" class="form-control" [disabled]="isManualEditMode">
            <option value="" disabled>Select Company</option>
            <option *ngFor="let c of availableCompaniesForManual" [value]="c.id">{{ c.company }}</option>
          </select>
        </div>
        <div class="form-group" *ngIf="manualInvoiceData.companyId">
          <label>Beginning Balance (Prev. Month Remaining)</label>
          <input type="text" [value]="isLoadingManualBalance ? 'Calculating...' : (manualBeginningBalance | currency:'USD')" class="form-control manual-readonly-input" readonly>
        </div>
      </div>

      <div *ngIf="manualInvoiceData.period && manualRates.length === 0" class="manual-warning">
        <span>Rate is not available. Please create rates for this period</span>
        <button class="action-btn utility-btn btn-create-rates" (click)="openRateCustomization(manualInvoiceData.period)">Create Rates</button>
      </div>

      <div *ngIf="manualInvoiceData.companyId" class="manual-content">
        <div class="manual-section-header">
          <h4 class="manual-section-title">Store Revenues</h4>
          <div class="manual-section-actions">
            <select [(ngModel)]="manualNewStoreId" class="form-control store-select">
              <option value="" disabled>Select Store</option>
              <option *ngFor="let s of availableStoresForManual" [value]="s.storeId">{{ s.storeId }}</option>
            </select>
            <button class="action-btn view-btn" (click)="addManualStore()" [disabled]="!manualNewStoreId">Add Store</button>
          </div>
        </div>

        <table class="data-grid">
          <thead>
            <tr>
              <th>Store</th>
              <th *ngFor="let rate of manualRates">{{ rate.name }}</th>
              <th class="col-delete"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of manualInvoiceData.items; let i = index">
              <td>{{ item.storeId }}</td>
              <td *ngFor="let rate of manualRates">
                <input type="number" [(ngModel)]="item.revenues[rate.id!]" class="table-input">
              </td>
              <td class="text-center">
                <button class="close-btn-static btn-remove" (click)="removeManualStore(i)">&times;</button>
              </td>
            </tr>
            <tr *ngIf="manualInvoiceData.items.length === 0">
              <td colspan="6" class="text-center no-stores-msg">No stores added.</td>
            </tr>
          </tbody>
        </table>

        <!-- Adjustments Section -->
        <div class="adjustments-header">
          <h4 class="manual-section-title">Adjustments / Refunds</h4>
          <button class="action-btn view-btn" (click)="addManualAdjustment()">Add Adjustment</button>
        </div>

        <table class="data-grid">
          <thead>
            <tr>
              <th>Description</th>
              <th *ngFor="let rate of manualRates">{{ rate.name }}</th>
              <th class="col-delete"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let adj of manualInvoiceData.adjustments; let i = index">
              <td><input type="text" [(ngModel)]="adj.name" class="table-input" placeholder="e.g. Refund"></td>
              <td *ngFor="let rate of manualRates">
                <input type="number" [(ngModel)]="adj.amounts[rate.id!]" class="table-input">
              </td>
              <td class="text-center">
                <button class="close-btn-static btn-remove" (click)="removeManualAdjustment(i)">&times;</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="invoice-footer">
      <button class="action-btn btn-cancel-manual" (click)="closeManualModal()">Cancel</button>
      <button class="action-btn save-btn" (click)="saveManualInvoice()" [disabled]="isLoadingGrid || manualRates.length === 0">
        {{ isLoadingGrid ? 'Saving...' : 'Save Invoice' }}
      </button>
    </div>
  </div>
</div>

<!-- History Modal -->
<div class="modal-overlay" *ngIf="isHistoryModalOpen" (click)="closeHistoryModal()">
  <div class="invoice-modal" data-testid="history-dialog" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Invoice History</h2>
      <button class="close-btn-static" (click)="closeHistoryModal()">&times;</button>
    </div>
    <div class="invoice-body">
      <div *ngIf="isLoadingHistory" class="loading-overlay">
        <div class="spinner"></div>
      </div>
      <table class="data-grid" *ngIf="!isLoadingHistory">
        <thead>
          <tr>
            <th>Date</th>
            <th>Category</th>
            <th>Field Changed</th>
            <th>Old Value</th>
            <th>New Value</th>
            <th>Activity By</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of invoiceHistory">
            <td>{{ item.activityDate?.toDate ? (item.activityDate.toDate() | date:'medium') : (item.activityDate | date:'medium') }}</td>
            <td>{{ item.category }}</td>
            <td>{{ item.fieldChanged }}</td>
            <td>{{ item.oldValue }}</td>
            <td>
              {{ item.newValue }}
            </td>
            <td>{{ item.activityBy }}</td>
          </tr>
          <tr *ngIf="invoiceHistory.length === 0">
            <td colspan="5" class="text-center no-history-msg">No history available.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-email-form 
  *ngIf="isEmailModalOpen" 
  [to]="emailData.to" 
  [subject]="emailData.subject" 
  [body]="emailData.body"
  (emailSent)="onEmailSent($event)"
  (close)="closeEmailModal(true)" 
  [attachments]="emailData.attachments"
>
</app-email-form>

<app-smrs-rate-popup [availableKeys]="extractedKeys" [periods]="periods"></app-smrs-rate-popup>

<!-- Payment Distribution Modal -->
<div class="modal-overlay overlay-z2000" *ngIf="isDistributionModalOpen" (click)="cancelDistribution()">
  <div class="invoice-modal distribution-modal" data-testid="distribution-modal" (click)="$event.stopPropagation()" style="width: 800px; padding: 30px;">
    <div class="modal-sticky-header" style="top: -30px; margin: -30px -30px 20px -30px; padding: 1rem 30px;">
      <h2>Payment Distribution Confirmation</h2>
      <button class="close-btn-static" (click)="cancelDistribution()">&times;</button>
    </div>
    
    <div class="invoice-body">
      <p style="margin-bottom: 20px; color: #475569;" *ngIf="!distributionData?.isReadOnly">
        You are applying a payment of <strong>{{ distributionData?.newAmountPaid | currency }}</strong>.
        Because there are unpaid balances from previous periods, this payment will be distributed sequentially to the oldest unpaid invoices:
      </p>
      <p style="margin-bottom: 20px; color: #475569;" *ngIf="distributionData?.isReadOnly">
        Payment of <strong>{{ distributionData?.newAmountPaid | currency }}</strong> was distributed sequentially to the oldest unpaid invoices:
      </p>
      
      <table class="data-grid" style="margin-bottom: 20px;">
        <thead>
          <tr>
            <th>Period</th>
            <th class="text-right">Total Due</th>
            <th class="text-right">Previously Paid</th>
            <th class="text-right">Applied from this Payment</th>
            <th class="text-right">Remaining Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of distributionData?.changes" [attr.data-testid]="'distribution-row-' + p.period">
            <td>{{ p.period }}</td>
            <td class="text-right">{{ p.totalDue | currency }}</td>
            <td class="text-right">{{ p.oldPaid | currency }}</td>
            <td class="text-right" data-testid="new-paid" [ngStyle]="{'color': (p.newPaid - p.oldPaid) > 0 ? '#16a34a' : ((p.newPaid - p.oldPaid) < 0 ? '#dc2626' : '')}">
              <strong>{{ (p.newPaid - p.oldPaid) > 0 ? '+' : '' }}{{ (p.newPaid - p.oldPaid) | currency }}</strong>
              <span *ngIf="p.newPaid !== (p.newPaid - p.oldPaid)" style="font-size: 0.8em; margin-left: 4px; color: #64748b;">
                (Total: {{ p.newPaid | currency }})
              </span>
            </td>
            <td class="text-right" data-testid="new-rem">{{ p.newRem | currency }}</td>
          </tr>
        </tbody>
      </table>

      <div class="duplicate-actions" style="margin-top: 20px;">
        <button class="action-btn cancel-edit" data-testid="btn-distribution-cancel" (click)="cancelDistribution()" [disabled]="isConfirmingDistribution">{{ distributionData?.isReadOnly ? 'Close' : 'Cancel' }}</button>
        <button *ngIf="!distributionData?.isReadOnly" class="action-btn save-btn" data-testid="btn-distribution-confirm" (click)="confirmDistribution()" [disabled]="isConfirmingDistribution" style="display: flex; align-items: center; justify-content: center;">
          <div *ngIf="isConfirmingDistribution" class="spinner-mini" style="margin-right: 8px; border-color: rgba(255, 255, 255, 0.3); border-top-color: white;"></div>
          {{ isConfirmingDistribution ? 'Confirming...' : 'Confirm & Apply' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Shared Sales Report Modal (opened by clicking company name) -->
<app-sales-report-modal
  [isOpen]="isSalesReportModalOpen"
  [company]="salesReportCompany"
  [period]="salesReportPeriod"
  [totalRevenue]="salesReportTotalRevenue"
  [showPdfActions]="true"
  (close)="closeSalesReportModal()"
></app-sales-report-modal>

<!-- Full-screen Blocking Import Overlay -->
<div *ngIf="isImporting" class="import-fullscreen-overlay">
  <div class="import-modal-card">
    <div class="import-spinner"></div>
    <h3 class="import-title">Importing Invoice Data</h3>
    <p class="import-status">{{ importStatusText }}</p>
    <div *ngIf="importProgress > 0 && importProgress < 100" class="import-progress-track">
      <div class="import-progress-fill" [style.width.%]="importProgress"></div>
    </div>
    <div class="import-warning-box">
      <span class="import-warning-icon">⚠️</span>
      <span class="import-warning-text">Please do not refresh, close, or navigate away from this page until the import completes.</span>
    </div>
  </div>
</div>